<template>
    <div :class="{'cursor-pointer': pointer}"
         class="flex-1 text-xl pb-2 pt-3"
         @click="click">
        <slot/>
    </div>
</template>

<script>
export default {
    props: {
        pointer: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        click() {
            this.$emit('click')
        }
    }
}
</script>
